import React from 'react'

import Head from 'next/head'
import { useRouter } from 'next/router'

import HeroFullVideo, { BGIMAGE } from '../components/Hero/HeroFullVideo'
import RowList from '../components/Main/RowList'
import ImageCallout from '../components/Main/ImageCallout'
import PartnerLogos from '../components/Main/PartnerLogos'
import CtaBanner from '../components/Main/CtaBanner'
import Page from '../components/Page'

export default function FilmFestival (props) {
  const router = useRouter()

  const isLiftTheMask = router.asPath.startsWith('/lift-the-mask-documentary')

  const {
    //Documentary intro fields connecting to HeroFullVideo
    documentary_still: {
      url: introImage,
      alt: alt,
      height: height,
      width: width,
      id: imageId
    },
    documentary_video_src: introVideo,
    documentary_heading: introHeading,
    documentary_subheading: introParagraph,

    //Image callout middle fields "Hosting Campus screening?"
    //callout_about_image: ,
    callout_about_image_caption: aboutCaption,
    callout_about_heading: aboutHeading,
    callout_about_sub_heading: aboutSubheading,
    callout_about_paragraph: aboutParagraph,
    callout_about_link: {
      url: aboutUrl,
      title: aboutLinkTitle,
      target: aboutLinkTarget
    },
    callout_about_column_order: aboutColOrder,
    intro_link_icon: aboutIcon,

    //image callout upper fields

    callout_upper_images: calloutImages,
    callout_upper_heading: calloutHeading,
    callout_upper_sub_heading: calloutSubheading,
    callout_upper_paragraph: calloutParagraph,
    callout_upper_link: { url: calloutUrl, title: calloutLinkTitle },
    callout_upper_sub_text: calloutSubText,
    callout_upper_column_order: colOrder,

    //CtaBanner Fields
    cta_heading: ctaHeading,
    cta_link: { url: ctaLink, title: ctaButton },

    //documentary been field group (Logos section)
    documentary_been_logos: documentaryLogos,
    documentary_been_heading: documentaryHeading,
    documentary_been_paragraph: documentaryParagraph,

    //Event Information fields
    event_info_heading: eventInfoHeading,
    event_info_date: eventInfoDate,
    event_info_time: eventInfoTime,
    event_info_location: eventInfoLocation,
    event_info_details: eventInfoDetails
  } = props.acf

  const hasEventInfo =
    eventInfoHeading ||
    eventInfoDate ||
    eventInfoTime ||
    eventInfoLocation ||
    eventInfoDetails

  console.log(aboutHeading)
  return (
    <React.Fragment>
      <Head>
        {/* Polaris */}
        {isLiftTheMask && (
          <>
            <script
              dangerouslySetInnerHTML={{
                __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer','GTM-5VRVLMZ');`
              }}
            />
            <script
              dangerouslySetInnerHTML={{
                __html: `(function(){ var e = document.getElementsByTagName("script")[0]; var d = document.createElement("script"); d.src = "//insiderdata360online.com/service/platform.js?ran="+Math.random(); d.type = "text/javascript"; d.async = true; d.defer = true; e.parentNode.insertBefore(d,e); })();`
              }}
            />
          </>
        )}
      </Head>
      <Page
        title={'Documentary'}
        body={calloutParagraph}
        heroTitle={introHeading}
        heroBody={introParagraph}
        bgVideo={introVideo}
        bgImage={introImage}
        height={900}
        width={1900}
        videoHeight={791}
        videoWidth={1500}
        slug={'/documentary'}
      >
        <main id='content'>
          <div className='scholarship-list'>
            <RowList
              title={aboutHeading}
              body={aboutParagraph}
              link={aboutUrl}
              target={aboutLinkTarget}
              button={aboutLinkTitle}
            />
          </div>

          {hasEventInfo && (
            <section className='event-info'>
              <div className='row'>
                <div className='col-10 offset-1 col-lg-8 offset-lg-2'>
                  {eventInfoHeading && (
                    <h2 className='heading2'>{eventInfoHeading}</h2>
                  )}

                  {(eventInfoDate || eventInfoTime || eventInfoLocation) && (
                    <div className='event-info__meta'>
                      {eventInfoDate && (
                        <p>
                          <strong>Date:</strong> {eventInfoDate}
                        </p>
                      )}

                      {eventInfoTime && (
                        <p>
                          <strong>Time:</strong> {eventInfoTime}
                        </p>
                      )}

                      {eventInfoLocation && (
                        <p>
                          <strong>Location:</strong> {eventInfoLocation}
                        </p>
                      )}
                    </div>
                  )}

                  {eventInfoDetails && (
                    <div
                      className='event-info__details'
                      dangerouslySetInnerHTML={{
                        __html: eventInfoDetails
                      }}
                    />
                  )}
                </div>
              </div>
            </section>
          )}
        </main>
      </Page>
      <style jsx>{`
        .scholarship-list,
        .event-info {
          margin: 200px 0;
        }

        .event-info__meta {
          margin-top: 40px;
        }

        .event-info__meta p {
          margin-bottom: 10px;
        }

        .event-info__details {
          margin-top: 30px;
        }
      `}</style>
    </React.Fragment>
  )
}
